// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'

import { string } from 'yup';


const obj =  {
	field:[
		
        { 
			title: "Topic or Keyword", 
			attr: "content",  
			value: "", 
			id:"topic",
			placeholder: "Specify content to generate stats and facts reagarding it", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or keyword is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
    example:[
	
        { 
			title: "Topic or Keyword", 
			attr: "content",  
			value: "Running", 
			id:"topic",
			placeholder: "Specify content to generate stats and facts reagarding it", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output:`• Running is the most popular form of exercise in the US, with around 64 million people participating each year. 
		\n• The average runner runs about 4 to 5 miles per hour. 
		\n• Running can help reduce stress and anxiety. Studies have found that running for 30 minutes a day can reduce symptoms of depression by up to 30%. 
		\n• Running has been linked to improved cardiovascular health, increased strength and endurance, improved mood, and better sleep. 
		\n• Research shows that running for at least 20 minutes a day can help reduce your risk of developing certain types of cancer by up to 40%. 
		\n• Regular runners live three years longer than non-runners on average. 
		\n• According to the American College of Sports Medicine, running is one of the best forms of exercise for weight loss due to its high calorie-burning potential.`,
        
	}
	}
	
	
	export default obj
	
	